<ng-container ngModelGroup="actions">
    <app-layout-row>
        <app-layout-column [width]="12">
            <h2>Add Actions</h2>
            <p>Do the following actions.</p>
        </app-layout-column>
    </app-layout-row>

    <app-layout-row>
        <app-layout-column [width]="12">
            <app-singleselectbox caption="Assign a Stakeholder" [ngModel]="$safeNavigationMigration(actions()?.StakeholderId)" name="stakeholderId"
                [dataSource]="stakeholders()" valueExpr="StakeholdersId" displayExpr="Name" required (ngModelChange)="onStakeholderChange($event)">
            </app-singleselectbox>
        </app-layout-column>
    </app-layout-row>

    <app-layout-row>
        <app-layout-column [width]="12">
            <app-checkbox name="notifyStakeholder" caption="Notify Stakeholder" [ngModel]="actions().NotifyStakeholder" (ngModelChange)="onNotifyStakeholderChange($event)"></app-checkbox>
        </app-layout-column>
    </app-layout-row>

    <app-layout-row>
        <app-layout-column [width]="12">
            <app-checkbox name="notifyStakeholderUrgent" caption="Notify Stakeholder Urgent" [ngModel]="actions().NotifyStakeholderUrgent" (ngModelChange)="onNotifyStakeholderUrgentChange($event)"></app-checkbox>
        </app-layout-column>
    </app-layout-row>

    <app-layout-row>
        <app-layout-column [width]="12">
            <app-checkbox name="notifySenderPartner" caption="Notify Sending Partner" [ngModel]="notifySenderPartner" #notifysender (valueChange)="onNotifySenderChange($event)"></app-checkbox>
        </app-layout-column>
    </app-layout-row>
    @if (notifysender.value()) {
    <app-layout-row [margin]="">
        <app-layout-column [width]="12">
            <app-singleselectbox caption="Sending Partner Contact Type" [ngModel]="actions().NotifySenderPartnerContactTypeId" name="notifySenderPartnerContactTypeId"
                [dataSource]="contactTypes()" valueExpr="Id" displayExpr="Name" required (ngModelChange)="onNotifySenderContactChange($event)">
            </app-singleselectbox>
        </app-layout-column>
    </app-layout-row>
    }

    <app-layout-row>
        <app-layout-column [width]="12">
            <app-checkbox name="notifyReceiverPartner" caption="Notify Receiving Partner" [ngModel]="notifyReceiverPartner" #notifyReceiver (valueChange)="onNotifyReceiverChange($event)"></app-checkbox>
        </app-layout-column>
    </app-layout-row>
    @if (notifyReceiver.value()) {
    <app-layout-row [margin]="">
        <app-layout-column [width]="12">
            <app-singleselectbox caption="Receiving Partner Contact Type" [ngModel]="actions().NotifyReceiverPartnerContactTypeId" name="notifyReceiverPartnerContactTypeId"
                [dataSource]="contactTypes()" valueExpr="Id" displayExpr="Name" required (ngModelChange)="onNotifyReceiverContactChange($event)">
            </app-singleselectbox>
        </app-layout-column>
    </app-layout-row>
    }

    <app-layout-row>
        <app-layout-column [width]="12">
            <app-checkbox name="reassign" caption="Reassign to error code" [ngModel]="reassign" #reassign2 (valueChange)="onReassignChange($event)"></app-checkbox>
        </app-layout-column>
    </app-layout-row>
    @if (reassign2.value()) {
    <app-layout-row [margin]="">
        <app-layout-column [width]="12">
            <app-textbox [ngModel]="actions().ReassignToErrorCode" name="reassignToErrorCode" caption="ErrorCode" required (ngModelChange)="onReassignErrorCodeChange($event)"></app-textbox>
        </app-layout-column>
    </app-layout-row>
    }

    <app-layout-row>
        <app-layout-column [width]="12">
            <app-checkbox name="setIgnoredStatus" caption="Set Ignored Status" [ngModel]="actions().SetIgnoredStatus" (ngModelChange)="onSetIgnoreChange($event)"></app-checkbox>
        </app-layout-column>
    </app-layout-row>

    <hr>
</ng-container>